import action from './action';
import loader from './loader';

const Component = () => import('./ProductDetailPage');

export { Component, loader, action };
